/**
 * Notifications API Module
 * CCH Care — Phase 2
 */
import client from './client';

export async function getNotifications({ unreadOnly = false, limit = 20 } = {}) {
  const response = await client.get('/care-notifications/list.php', {
    params: { unread_only: unreadOnly ? '1' : '0', limit }
  });
  return response.data;
}

export async function markRead(notificationId) {
  const response = await client.post('/care-notifications/read.php', {
    notification_id: notificationId
  });
  return response.data;
}

export async function markAllRead() {
  const response = await client.post('/care-notifications/read.php', {
    mark_all: true
  });
  return response.data;
}
